import { render, staticRenderFns } from "./howToKnowTermsOfCashBack.vue?vue&type=template&id=74be21ab&scoped=true"
import script from "./howToKnowTermsOfCashBack.vue?vue&type=script&lang=js"
export * from "./howToKnowTermsOfCashBack.vue?vue&type=script&lang=js"
import style0 from "./howToKnowTermsOfCashBack.vue?vue&type=style&index=0&id=74be21ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74be21ab",
  null
  
)

export default component.exports